import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules, provideRouter, RouterFeatures, withPreloading, withRouterConfig } from '@angular/router';
import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app-routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CoreModule } from '../src/app/core/core.module';
import { SharedModule } from '../src/app/shared/shared.module';
import { VegWizardModule } from '../src/app/veg-wizard/veg-wizard.module';
import { httpRequestInterceptor } from '../src/app/http-interceptor-fn';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletDrawModule } from '@bluehalo/ngx-leaflet-draw';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

if (environment.production) {
  enableProdMode();
}
const routeFeatures: RouterFeatures[] = [];

routeFeatures.push(withRouterConfig({ paramsInheritanceStrategy: 'always' }));
routeFeatures.push(withPreloading(PreloadAllModules));

bootstrapApplication(AppComponent, {
  providers: [
    // Router and HashLocationStrategy
    provideZoneChangeDetection(),provideRouter(APP_ROUTES, ...routeFeatures),
    { provide: LocationStrategy, useClass: HashLocationStrategy },

    // Import external modules
    importProvidersFrom(
      SharedModule,
      CoreModule,
      VegWizardModule,
      LeafletModule,
      LeafletDrawModule,
      MatProgressSpinnerModule
    ),

    // HTTP client and interceptors
    provideHttpClient(
      withInterceptors(
        [
          httpRequestInterceptor,
        ])),

    provideAnimationsAsync(),
  ]
})
  .catch(err => console.error(err));